<template>
  <Toast
    group="app-update"
    position="bottom-left"
    style="z-index: 999"
  >
    <template #container>
      <AppToastNotificationAppUpdateContainer />
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
</script>
